import { subject } from '@casl/ability'
import { HStack, IconButton, Spacer } from '@chakra-ui/react'
import type { FC } from 'react'
import { FiTrash2 } from 'react-icons/fi'
import { PiPower, PiProhibit } from 'react-icons/pi'

import { Tooltip } from '@app/components/ui/tooltip'
import useStoreCurrentUser from '@app/hooks/useStoreCurrentUser'
import AccountAccessToggleButton from '@app/pages/settings/organization/components/accountAccessToggleButton'
import AccountDeleteButton from '@app/pages/settings/organization/components/accountDeleteButton'
import Can from '@app/shared/authorization/can'
import type { Account } from '@graphql/types'

interface Props {
  account: Account
}

const AccountsListActions: FC<Props> = ({ account }) => {
  const { user } = useStoreCurrentUser()
  const { id, role } = account

  return (
    <Can I="update" this={subject('account', { id, organizationId: user?.organization?.id, role })}>
      <HStack gap={0}>
        <Spacer />
        <AccountAccessToggleButton account={account}>
          <Tooltip content={`${account.disabledAt ? 'Activate' : 'Deactivate'} account`}>
            <IconButton aria-label={`${account.disabledAt ? 'Activate' : 'Deactivate'} account`} variant="ghost">
              {account.disabledAt ? <PiPower /> : <PiProhibit />}
            </IconButton>
          </Tooltip>
        </AccountAccessToggleButton>
        <AccountDeleteButton account={account}>
          <Tooltip content="Delete account">
            <IconButton aria-label="Delete accoount" variant="ghost">
              <FiTrash2 />
            </IconButton>
          </Tooltip>
        </AccountDeleteButton>
      </HStack>
    </Can>
  )
}

export default AccountsListActions
